<template>
  <div class="md-layout card-relatorio">

    <toolbar v-if="form.id != null && form.id != undefined" :item="form" tipo="relatorio"></toolbar>


    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>assignment</md-icon>
          </div>
          <h4 class="title">{{titulo}}</h4>
        </md-card-header>

        <md-card-content>
          <slot name="body">
            <div v-if="loading" class="md-layout">
              <div class="md-layout-item md-size-100 box-carregando">
                <md-progress-spinner
                  :md-diameter="40"
                  :md-stroke="4"
                  md-mode="indeterminate"
                >{{msg_status}}</md-progress-spinner>
              </div>
            </div>

            <div class="md-layout">
              <div class="md-layout-item md-size-25 md-small-size-50 md-xsmall-size-100 mb-20">
                <label class="md-form-label">ID</label>
                <div class="md-form-text">{{form.id}}</div>
              </div>
              <div class="md-layout-item md-size-25 md-small-size-50 md-xsmall-size-100 mb-20">
                <label class="md-form-label">Cliente / Empresa</label>
                <div class="md-form-text">{{form.nome_cliente}}</div>
              </div>
              <div class="md-layout-item md-size-25 md-small-size-50 md-xsmall-size-100 mb-20">
                <label class="md-form-label">Nutricionista Responsável</label>
                <div class="md-form-text">{{form.nutricionista_responsavel}}</div>
              </div>
              <div class="md-layout-item md-size-25 md-small-size-50 md-xsmall-size-100 mb-20">
                <label class="md-form-label">Responsável Estabelecimento</label>
                <div class="md-form-text">{{form.responsavel_estabelecimento}}</div>
              </div>
              <div class="md-layout-item md-size-25 md-small-size-50 md-xsmall-size-100 mb-20">
                <label class="md-form-label">Data</label>
                <div class="md-form-text">{{form.data | date_show}}</div>
              </div>
              <div class="md-layout-item md-size-25 md-small-size-50 md-xsmall-size-100 mb-20">
                <label class="md-form-label">Entrada</label>
                <div class="md-form-text">{{form.data_entrada | hora_show}}</div>
              </div>
              <div class="md-layout-item md-size-25 md-small-size-50 md-xsmall-size-100 mb-20">
                <label class="md-form-label">Saída</label>
                <div class="md-form-text">{{form.data_saida | hora_show}}</div>
              </div>
            </div>
          </slot>
        </md-card-content>
      </md-card>
    </div>

    <div
      class="md-layout-item md-size-100"
      v-if="form.textos != null && form.textos != undefined && form.textos.length > 0 "
    >
      <md-card v-for="(item,index) in form.textos" :key="index">
        <md-card-header class="md-card-header-text md-card-header-green">
          <div class="card-text">
            <slot name="header">
              <h4 class="title" v-html="item.titulo"></h4>
            </slot>
          </div>
        </md-card-header>
        <md-card-content>
          <slot name="body">
            <div class="list-custom">
              <div class="md-layout-item md-size-85 md-small-size-75 md-xsmall-size-100 content">
                <p v-html="item.texto"></p>
              </div>
            </div>
          </slot>
        </md-card-content>
      </md-card>
    </div>

    <div class="md-layout-item md-size-100" v-if="show_produtos">
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-green">
          <div class="card-text">
            <slot name="header">
              <h4 class="title">Produtos</h4>
            </slot>
          </div>
        </md-card-header>
        <md-card-content>
          <slot name="body">
            <div class="list-custom">
              <table class="striped">
                <thead>
                  <tr>
                    <th>Setor</th>
                    <th>Produto / Marca</th>
                    <th>Lote</th>
                    <th>Qtde</th>
                    <th>Vencimento</th>
                    <th>Observação</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in form.produtos" :key="index">
                    <td>{{item.setor}}</td>
                    <td>{{item.produto}}</td>
                    <td>{{item.lote}}</td>
                    <td>{{item.qtde}}</td>
                    <td>{{item.vencimento}}</td>
                    <td>{{item.observacao}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </slot>
        </md-card-content>
      </md-card>
    </div>

    <div
      class="md-layout-item md-size-100"
      v-if="form != null && form.arquivos != null && form.arquivos != undefined && form.arquivos.length > 0"
    >
      <!-- Info -->
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>image</md-icon>
          </div>
          <h4 class="title">Imagens / Arquivos</h4>
        </md-card-header>
        <md-card-content class="box-info">
          <slot name="body">
            <div class="md-layout-item md-size-85 md-small-size-75 md-xsmall-size-100 content">
              <div class="group-img">
                <show_image :arquivos="form.arquivos" caption="Images / Arquivos"></show_image>
                <!--    <a href="#!" class="item-img" v-for="arquivo in form.arquivos" :key="arquivo.id">
                                              <img class="img-responsive" v-bind:src="arquivo.url_thumb" alt="Imagem">
                </a>-->
              </div>
            </div>
          </slot>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<style scoped>
@import "../../../assets/css/validate.css";
@import "../../../assets/css/form_custom.css";
</style>
<script>
import service from "../../../services/RelatorioService";
import autocomplete from "../../../components/Rend/autocomplete";
import filelogo from "../../../components/Rend/filelogo";
import mixin_validator from "../../../library/mixin/validator";
import mixin_util from "../../../library/mixin/util";
import modal from "../../../components/Modal";
import Datepicker from "../../../components/Rend/vuejs-datepicker/src/components/Datepicker";
import ptBR from "../../../components/Rend/vuejs-datepicker/src/locale/translations/pt-BR";
import CardCadastro from "../../../components/CardCadastro";
import vue_select from "../../../components/Rend/vue-select/src/Select.vue";
import show_image from "../../../components/Rend/show-image/show.vue";
import toolbar from '../components/toolbar_visualizar.vue';

export default {
  components: {
    autocomplete,
    filelogo,
    modal,
    Datepicker,
    CardCadastro,
    vue_select,
    show_image,
    toolbar
  },

  mixins: [mixin_util, mixin_validator],
  props: ["id_load", "show_back_button", "onBack", "onSave"],
  data() {
    return {
      acao: "Cadastrar",
      form: {},
      perfis: [],
      clientes: [],
      clientes_list: [],
      show_perfil: false,
      file_upload: null,
      botao_voltar_visible: true,
      loading: true,
      result2: "",
      disableButton: false,
      show_message: "off",
      message_text: "",
      message_type: "success",
      interval_message: null,
      showDialogError: false,
      msg_status: "Carregando",
      show_modal_contacts: false,
      show_sub_form: true,
      data: null,
      data_cadastro: null,
      language_date: ptBR,
      title: "Relatório de auditoria técnica",
      icone_title: "assignment",
      titulo: "",
      show_produtos: false
    };
  },
  mounted() {
    let self = this;
    this.form = service.getModelVisualizar();
    this.configureMessages();

    if (this.show_back_button != null && this.show_back_button != undefined) {
      this.botao_voltar_visible = this.show_back_button;
    }

    this.disableButton = true;

    if (
      this.id_load != null &&
      this.id_load != undefined &&
      this.id_load != ""
    ) {
      service
        .getViewCompleta(this.id_load, "id", "asc")
        .then(function(response) {
          self.form = response.data;

          self.loading = false;
          self.disableButton = false;

          if (
            self.form.produtos != null &&
            self.form.produtos != undefined &&
            self.form.produtos.length > 0
          ) {
            self.show_produtos = true;
          }
        });
    } else {
      this.loading = false;
      this.disableButton = false;
    }

    this.$store.dispatch("setButtonBack", {
      in_form: true,
      rota: "inspecao",
      exibe: this.show_back_button,
      onBack: this.onBack
    });
    //this.$store.dispatch("user/save", this.tmpUser)
  },
  methods: {
    mostra_nota(nota) {
      if (nota == null) return "N/C";

      if (nota == 0) return "N/C";

      if (nota == -1) return "N/A";

      return "C";
    },

    botao_voltar() {
      var self = this;

      if (this.onBack != null && this.onBack != undefined) {
        this.onBack(self);
      }
    },
    changed(prop) {},

    configureMessages() {
      const dict = {
        // email: {
        //   required: 'O e-mail não pode ser vazio!',
        //   email: 'É necessário informar um e-mail válido!'
        // },
        nome: {
          required: "Nome não pode ser vazio!"
        }
        // cnpj: {
        //   required: 'CPF/CNPJ não pode ser vazio!',
        // cpf: true //testará o método de CPF
        // }
      };

      this.setFieldsValidator(dict);

      //this.p_validator.localize('en', dict);
    },
    onPreSaveContatos() {
      this.show_sub_form = false;
    },
    onPosSaveContatos(itens) {
      this.show_sub_form = true;
    },
    salvar() {
      var self = this;

      if (!this.validar()) return false;

      self.msg_status = "Salvando..";
      self.loading = true;
      self.data = Util.dateToBd(self.data);
      self.data_cadastro = Util.dateToBd(self.data_cadastro);

      service
        .salvar(this.form)
        .then(function(response) {
          var retorno = response.data;

          self.show_message = "on";
          self.message_text = "inspecao salvo com sucesso!";

          self.interval_message = setInterval(self.clear_message, 6000);

          var item = retorno.item;

          self.msg_status = "Carregando..";
          self.loading = false;

          self.form = item;

          self.titulo = service.getTitulo(item.tipo);

          if (self.onSave != null && self.onSave != undefined) {
            self.onSave(retorno, "save");
          }
        })
        .catch(function(error) {});
    },

    excluir() {
      let self = this;
      self.msg_status = "Excluindo..";
      self.loading = true;

      var fn_return = function(response) {
        var retorno = response.data;
        if (self.onSave != null && self.onSave != undefined) {
          self.onSave(retorno, "delete");
        }
        self.msg_status = "Carregando..";
        self.loading = false;
        self.botao_voltar();
      };
      if (this.form.id == null) return false;

      service.delete(this.form.id).then(fn_return);
      //	obj_api.call_delete("cliente", this.id, fn_return);
    },
    clear_message() {
      this.show_message = "off";
      clearInterval(this.interval_message);
    },
    hideModal() {
      this.showDialogError = false;
    },
    validar() {
      this.indicateAllErrors(); //Verifica todos os possíveis erros em tela.
      console.log("erros? ");
      console.log(this.p_validator.errors);

      if (this.p_validator.errors.length > 0) {
        this.showDialogError = true;
        return false;
      }

      return true;
    }
  }
};
</script>